/**
 * Visual constants for the Peersona panel. Centralized so the theme
 * swaps in one place. Distinct from the Fi palette on purpose.
 */

export const PEERSONA_GRADIENT_FROM = '#6B6FFF';
export const PEERSONA_GRADIENT_TO = '#A275FF';

export const PEERSONA_PANEL_BG = '#FFFFFF';

// Chat bubbles. Asymmetric corner radii are applied in PeersonaMessageBubble.
export const PEERSONA_BUBBLE_USER_BG = '#5E5E79'; // Shades/Dark Gray
export const PEERSONA_BUBBLE_USER_TEXT = '#FFFFFF';
export const PEERSONA_BUBBLE_ASSISTANT_BG = '#3C87FF'; // Kindly Human Blue
export const PEERSONA_BUBBLE_ASSISTANT_TEXT = '#FFFFFF';
export const PEERSONA_BUBBLE_ASSISTANT_BORDER = 'transparent';

// Text + chrome palette.
export const PEERSONA_TEXT_PRIMARY = '#000000';
export const PEERSONA_TEXT_SECONDARY = '#62748E';
export const PEERSONA_TEXT_TERTIARY = '#5E5E79';
export const PEERSONA_TEXT_MUTED = '#90A1B9';
export const PEERSONA_DIVIDER = 'rgba(144,161,185,0.2)';
export const PEERSONA_CHIP_BG = '#F3F3FA';

// Peer-lookup card — softer sibling of the referral card.
export const PEERSONA_PEER_LOOKUP_CARD_BG = '#F8F6FF';
export const PEERSONA_PEER_LOOKUP_CARD_BORDER = 'rgba(98, 71, 234, 0.25)';
export const PEERSONA_PEER_LOOKUP_ACCENT = '#5B5FE5';

export const PEERSONA_REFERRAL_CARD_BG = '#FFFFFF';
export const PEERSONA_REFERRAL_CARD_BORDER = 'rgba(98, 71, 234, 0.35)';
export const PEERSONA_REFERRAL_ACCENT = '#5B5FE5';

// Safety card — warm rust-orange instead of alarm red.
export const PEERSONA_SAFETY_CARD_BG = '#FFF8F2';
export const PEERSONA_SAFETY_CARD_BORDER = 'rgba(193, 95, 38, 0.35)';
export const PEERSONA_SAFETY_ACCENT = '#C15F26';
export const PEERSONA_SAFETY_LABEL = 'Resources you can reach for right now';
